import React from 'react';
import LoginForm from '@/components/LoginForm';
import LoginFooter from '@/components/LoginFooter';

const LoginPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-westfalen-gradient p-4 relative">
      <div className="w-full max-w-md">
        <LoginForm />
      </div>
      <LoginFooter />
    </div>
  );
};

export default LoginPage;
